import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=4b869f7a&scoped=true"
import script from "./AdminLogin.vue?vue&type=script&lang=js"
export * from "./AdminLogin.vue?vue&type=script&lang=js"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=4b869f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b869f7a",
  null
  
)

export default component.exports